import dynaForms from '@elab/core/utils/dynaForms';
import { SHARED_ACTIONS } from '@elab/core/utils/constants';

const getTypes = storeName => ({
    ...dynaForms.getTypes(storeName),
    HIDE_GUEST_CHECKOUT: `${storeName}.HIDE_GUEST_CHECKOUT`,
    SET_DATA_FIELD_VALUE: `${storeName}.SET_DATA_FIELD_VALUE`,
    SET_FORM_IS_LOADED: `${storeName}.SET_FORM_IS_LOADED`,
    SET_CUSTOMER_LOYALTY_STATUS: `${storeName}.SET_CUSTOMER_LOYALTY_STATUS`,
    SET_AUTH_OPTION: `${storeName}.SET_AUTH_OPTION`,
    PREVIOUS_STEP: `${storeName}.PREVIOUS_STEP`,
    SET_IS_PIN_CODE_OR_DOB_VALID: `${storeName}.${SHARED_ACTIONS.setIsPinCodeOrDOBValid}`,
    SHOW_PINCODE: `${storeName}.SHOW_PINCODE`,
    SUBMIT_WITHOUT_PHONE_VERIFICATION: `${storeName}.SUBMIT_WITHOUT_PHONE_VERIFICATION`,
    PHONE_DOB_RECEIVED: `${storeName}.PHONE_DOB_RECEIVED`,
});

export default getTypes;
